module.exports = __webpack_public_path__ + "static/media/logo.26be8d6c.svg";